import Amount from "@/models/Shared/Amount";

export default class CreateUserRequest {
    firstName: string = '';
    lastName: string = '';
    email: string = '';
    phone: string = '';
    enabled: boolean = true;
    paymentOrderApprovalLimit: Amount = new Amount();
    paymentOrderApprovalNotificationLowerLimit: Amount = new Amount();
}